/**
 * Every enum here is transcribed verbatim from backend `src/constants/webhook.constants.ts`.
 * The prototype and the Notion doc both name events that do not exist there
 * (`payment.succeeded`, `payment.failed`, `collected-data.completed`) — they are validated with
 * `@IsEnum` on both create and send, so an invented value is a 400, never a no-op.
 */
export enum WebhookEventType {
  ContractorActivated = 'contractor.activated',
  ContractorDeactivated = 'contractor.deactivated',
  ContractorCreated = 'contractor.created',
  ContractorUpdated = 'contractor.updated',
  ContractorCollectedDataUpdate = 'contractor.collected-data-update',
  CollectedDataCreated = 'collected-data.created',
  CollectedDataUpdated = 'collected-data.updated',
  CollectedDataDeleted = 'collected-data.deleted',
  PaymentCreated = 'payment.created',
  PaymentUpdated = 'payment.updated',
  PaymentDeleted = 'payment.deleted',
  PaymentVoided = 'payment.voided',
}

export enum WebhookResourceType {
  Contractor = 'contractor',
  CollectedData = 'collected-data',
  Payment = 'payment',
}

/** The success value is the string `success`; it is *labelled* "Delivered", never renamed. */
export enum WebhookDeliveryStatus {
  Success = 'success',
  Pending = 'pending',
  Failed = 'failed',
}

export enum WebhookVersion {
  V1 = '1',
  V2 = '2',
}

/** `api` rows were created by the customer through the `customer.webhook` OAuth scope. */
export enum WebhookCreationSource {
  Admin = 'admin',
  Api = 'api',
}

export enum WebhookSubscriptionsTableFields {
  callbackUrl = 'callbackUrl',
  events = 'events',
  isActive = 'isActive',
  creationSource = 'creationSource',
  createdAt = 'createdAt',
  id = 'id',
  actions = 'actions',
}

export enum WebhookDeliveriesTableFields {
  deliveryStatus = 'deliveryStatus',
  eventType = 'eventType',
  resourceId = 'resourceId',
  createdAt = 'createdAt',
  actions = 'actions',
}
